<template>
  <div class="simple-page">
    <a-card :bordered="false">
      <div class="page-box">
        <div class="page-title">
          <span>个人设置</span>
        </div>
        <a-row :gutter="24">
          <a-col :span="24">
            <a-list
                itemLayout="horizontal"
            >
              <a-list-item>
                <a-list-item-meta>
                  <span slot="title">账户</span>
                  <p slot="description">
                    <span>{{ this.admin.account }}</span>
                  </p>
                </a-list-item-meta>
              </a-list-item>
              <a-list-item>
                <a-list-item-meta>
                  <span slot="title">密码</span>
                  <p slot="description">
                    <span>******</span>
                  </p>
                </a-list-item-meta>
                <a slot="actions" @click="setPassword">修改</a>
              </a-list-item>
              <a-list-item>
                <a-list-item-meta>
                  <span slot="title">姓名</span>
                  <p slot="description">
                    <span>{{ this.admin.username }}</span>
                  </p>
                </a-list-item-meta>
                <a slot="actions" @click="setItem('姓名', 'username', admin.username)">修改</a>
              </a-list-item>
              <a-list-item>
                <a-list-item-meta>
                  <span slot="title">电话</span>
                  <p slot="description">
                    <span>{{ this.admin.tel }}</span>
                  </p>
                </a-list-item-meta>
                <a slot="actions" @click="setItem('电话', 'tel', admin.tel)">修改</a>
              </a-list-item>
              <a-list-item>
                <a-list-item-meta>
                  <span slot="title">邮箱</span>
                  <p slot="description">
                    <span>{{ this.admin.mail }}</span>
                  </p>
                </a-list-item-meta>
                <a slot="actions" @click="setItem('邮箱', 'mail', admin.mail)">修改</a>
              </a-list-item>
            </a-list>
          </a-col>
        </a-row>
      </div>

      <set-password-modal
        ref="setPassword"
        :visible="setPasswordVisible"
        @cancel="setPasswordCancel"
        @ok="setPasswordOk"
      />

      <set-item-modal
        ref="setItem"
        :visible="setItemVisible"
        :item="item"
        @cancel="setItemCancel"
        @ok="setItemOk"
      />
    </a-card>
  </div>
</template>

<script>
import SetItemModal from "./SetItem";
import SetPasswordModal from "./SetPassword";
import { setting, setItem, setPassword } from "@/api/app";

export default {
  components: {
    SetItemModal,
    SetPasswordModal
  },
  data() {
    return {
      admin: {},
      item: {},
      setItemVisible: false,
      setPasswordVisible: false
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      setting().then(res => {
        this.admin = res.data.admin;
      });
    },
    setItem(label, field, val) {
      this.item = {
        label: label,
        field: field,
        val: val
      };
      this.setItemVisible = true;
    },
    setItemCancel() {
      this.setItemVisible = false;
      if (this.$refs.setItem && this.$refs.setItem.initForm) {
        this.$refs.setItem.initForm();
      }
    },
    setItemOk() {
      const modal = this.$refs.setItem;
      if (!modal || !modal.$refs.adminForm) return;
      modal.$refs.adminForm.validate((valid) => {
        if (!valid) return;
        setItem({ ...modal.form }).then(() => {
          this.setItemVisible = false;
          this.$message.success('修改成功');
          this.fetchData();
        });
      });
    },
    setPassword() {
      this.setPasswordVisible = true;
    },
    setPasswordCancel() {
      this.setPasswordVisible = false;
      if (this.$refs.setPassword && this.$refs.setPassword.initForm) {
        this.$refs.setPassword.initForm();
      }
    },
    setPasswordOk() {
      const modal = this.$refs.setPassword;
      if (!modal || !modal.$refs.adminForm) return;
      modal.$refs.adminForm.validate((valid) => {
        if (!valid) return;
        setPassword({ ...modal.form }).then(() => {
          this.setPasswordVisible = false;
          this.$message.success('修改密码成功');
          this.fetchData();
        });
      });
    }
  }
}
</script>

<style lang="less" scoped>
.simple-page {
  margin: 16px;

  .page-box {
    margin: 12px 50px;
    min-height: 580px;
    width:800px;

    .page-title {
      color: rgba(0,0,0,.85);
      font-size: 18px;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 12px;
    }
  }
}
</style>